/**
 * @generated SignedSource<<4d372ec4a501e2530013904a600243e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingWriteAccess = "FULL_WRITE" | "JOIN" | "NONE" | "NON_OWNER_WRITE";
import { FragmentRefs } from "relay-runtime";
export type JoinBookingButton_Booking$data = {
  readonly id: string;
  readonly writeAccess: BookingWriteAccess | null | undefined;
  readonly " $fragmentType": "JoinBookingButton_Booking";
};
export type JoinBookingButton_Booking$key = {
  readonly " $data"?: JoinBookingButton_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"JoinBookingButton_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JoinBookingButton_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "writeAccess",
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "0bcc594744a94f54fb45569a01a40b6d";

export default node;
